import classnames from 'classnames/bind'
import InternalScoutClient from 'clients/cooperation/internal_scout_client'
import IntroducerLabel from 'components/introducer_label'
import IntroducerSelector from 'components/introducer_selector'
import Company from 'entities/company'
import Group from 'entities/group'
import Offer from 'entities/offer'
import Recruiter from 'entities/recruiter'
import { isEmpty, trim } from 'lodash'
import { MdClose, MdCheck, MdWarning } from 'react-icons/md'
import PropTypes from 'prop-types'
import PubSub from 'pubsub-js'
import React, { Component } from 'react'
import Modal from 'react-overlays/lib/Modal'
import { propTypeInstantiableTo } from 'supports/custom_prop_types'
import { formatted } from 'i18n/i18n.tsx'
import styles from './internal_scout_form.module.scss'

const cx = classnames.bind(styles)
export default class InternalScoutForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showModal: props.showModal,
      isLoading: false,
      isApplied: false,
      keyword: null,
      internalScout: null,
      error: null,
      company: new Company(props.company),
      offer: new Offer(props.offer),
      group: new Group(props.group),
      searchGroup: new Group(props.searchGroup),
      introducer: props.introducer ? new Recruiter(props.introducer) : null,
      prevPropsShowModal: props.showModal,
      onClose: props.onClose
    }
    this.handleSelectIntroducer = this.handleSelectIntroducer.bind(this)
    this.handleDeselectIntroducer = this.handleDeselectIntroducer.bind(this)
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // propsの変化でも開けられるようにする
    if (nextProps.showModal !== prevState.prevPropsShowModal) {
      return {
        showModal: nextProps.showModal,
        internalScout: null,
        error: null,
        isApplied: false,
        prevPropsShowModal: nextProps.showModal
      }
    }
    return null
  }

  componentDidUpdate(prevProps, prevState) {
    const { introducer } = this.state

    if (introducer) {
      if (!prevState.introducer) {
        // 紹介者がセットされたら通知する
        PubSub.publish(IntroducerSelector.TOPIC_DESELECT_INTRODUCER)
      }
    } else if (prevState.introducer) {
      // 紹介者が削除されたら通知する
      PubSub.publish(IntroducerSelector.TOPIC_SELECT_INTRODUCER)
    }
  }

  show() {
    this.setState({
      showModal: true
    })
    this.initialize()
  }

  hide() {
    this.setState({
      showModal: false
    })
    this.initialize()
    const { onClose } = this.state
    onClose()
  }

  initialize() {
    this.setState({
      internalScout: null,
      error: null,
      isApplied: false
    })
  }

  handleSubmit(e) {
    e.preventDefault()

    this.setState({
      isLoading: true
    })

    const formData = new FormData(e.target)
    InternalScoutClient.post(formData)
      .then(internalScout => {
        this.setState({
          internalScout,
          isApplied: true,
          error: null,
          isLoading: false
        })
      })
      .catch(error => {
        const isApplied = !isEmpty(error.fieldErrors.filter(fieldError => fieldError.field === 'base'))
        this.setState({
          error,
          isApplied,
          isLoading: false
        })
      })
  }

  handleInputName(e) {
    const keyword = trim(e.target.value)
    this.setState({
      keyword: !keyword || keyword.length === 0 ? null : keyword
    })
  }

  handleSelectIntroducer(introducer) {
    this.input.value = null
    this.setState({
      introducer,
      keyword: null
    })
  }

  handleDeselectIntroducer() {
    this.input.value = null
    this.setState({
      introducer: null,
      keyword: null
    })
  }

  renderAppliedMessages() {
    const { internalScout, error } = this.state
    if (internalScout) {
      return (
        <div className={styles.appliedContainer}>
          <div className={styles.applySuccess}>
            <MdCheck size={54} />
            <p>{I18n.t('offers.pages.internal_scout_form.message.complete')}</p>
          </div>
        </div>
      )
    }

    const messages = error.fieldErrors
      .filter(fieldError => fieldError.field === 'base')
      .map(fieldError => <span key={fieldError.message}>{fieldError.message}</span>)

    return (
      <div className={styles.appliedContainer}>
        <div className={styles.applyFailure}>
          <MdWarning size={54} />
          <p>{!isEmpty(messages) ? messages : I18n.t('offers.pages.internal_scout_form.message.failure')}</p>
        </div>
      </div>
    )
  }

  render() {
    const { company, offer, group, introducer, isLoading, keyword, searchGroup, showModal, isApplied } = this.state
    const { contentId, deviceName, selectable } = this.props

    return (
      <Modal show={showModal}>
        <div className={styles.modal}>
          <div className={styles.modalInner}>
            <div className={styles.modalHeader}>
              <span>{I18n.t('offers.pages.internal_scout_form.title')}</span>
              <button type="button" className={cx(styles.button, styles.closeButton)} onClick={() => this.hide()}>
                <MdClose size={24} />
              </button>
            </div>
            <div className={styles.modalContent}>
              <form onSubmit={e => this.handleSubmit(e)}>
                <input type="hidden" name="token_company" defaultValue={company.token} />
                <input type="hidden" name="token_group" defaultValue={group.token} />
                <input type="hidden" name="token_offer" defaultValue={offer.token} />
                <input type="hidden" name="token_recruiter" defaultValue={introducer ? introducer.token : undefined} />
                <input type="hidden" name="internal_scout[_keep]" value="1" />
                <input type="hidden" name="content_id" defaultValue={contentId} />
                {isApplied ? (
                  this.renderAppliedMessages()
                ) : (
                  <>
                    <div className={styles.formContainer}>
                      <div className={styles.helpText}>
                        {formatted('offers.pages.internal_scout_form.help_text', {
                          title: <strong>{offer.scoutTitle}</strong>
                        })}
                      </div>
                      <div className="form-group">
                        <div className="form-group-label">
                          {I18n.t('offers.pages.internal_scout_form.recruiter_name.label')}
                          <span className="is-required">{I18n.t('common.required')}</span>
                        </div>
                        {
                          <>
                            <IntroducerLabel
                              device_name={deviceName}
                              introducer={introducer}
                              selectable={selectable}
                              onClickDeselect={() => this.handleDeselectIntroducer()}
                            />
                            <div
                              className={cx(styles.formGroupCotainer, {
                                formGroupCotainerSelected: introducer !== null
                              })}
                            >
                              <input
                                type="text"
                                className="form-control"
                                ref={ref => {
                                  this.input = ref
                                }}
                                placeholder={I18n.t('offers.pages.internal_scout_form.recruiter_name.placeholder')}
                                onKeyUp={e => this.handleInputName(e)}
                                onCompositionEnd={e => this.handleInputName(e)}
                              />
                            </div>
                            <IntroducerSelector
                              keyword={keyword}
                              company_token={company.token}
                              offer_token={offer.token}
                              group_token={searchGroup.token}
                              selectable={selectable}
                              onSelectIntroducer={selectedIntroducer => this.handleSelectIntroducer(selectedIntroducer)}
                            />
                          </>
                        }
                      </div>
                    </div>
                    <div className={styles.submitContainer}>
                      <input
                        type="submit"
                        className={cx(styles.button, styles.buttonSubmit)}
                        value={I18n.t('offers.pages.internal_scout_form.submit')}
                        disabled={isLoading || !introducer}
                      />
                    </div>
                  </>
                )}
              </form>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

InternalScoutForm.propTypes = {
  company: propTypeInstantiableTo(Company).isRequired,
  offer: propTypeInstantiableTo(Offer).isRequired,
  group: propTypeInstantiableTo(Group).isRequired,
  searchGroup: propTypeInstantiableTo(Group).isRequired,
  selectable: PropTypes.bool.isRequired,
  deviceName: PropTypes.string.isRequired,
  contentId: PropTypes.number,
  introducer: propTypeInstantiableTo(Recruiter),
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}

InternalScoutForm.defaultProps = {
  contentId: null,
  introducer: null
}
